import { render, staticRenderFns } from "./UIIcon.vue?vue&type=template&id=3f9ba131&scoped=true"
import script from "./UIIcon.vue?vue&type=script&lang=js"
export * from "./UIIcon.vue?vue&type=script&lang=js"
import style0 from "./UIIcon.vue?vue&type=style&index=0&id=3f9ba131&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9ba131",
  null
  
)

export default component.exports